/* DidWell theme behaviour: Buy-now fallback (when the custom checkout app is off) and the sticky buy bar. */
(function () {
  'use strict';

  // Fallback Buy now: send the shopper straight to Shopify checkout with just this item.
  // Only used when the theme setting "Checkout app URL" is empty (the button then carries data-dw-buynow).
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-dw-buynow]');
    if (!button) return;
    event.preventDefault();
    var variantId = button.getAttribute('data-dw-buynow');
    if (!variantId) return;
    button.setAttribute('aria-busy', 'true');
    window.location.href = button.getAttribute('href') || ('/cart/' + encodeURIComponent(variantId) + ':1');
  });

  // Mobile menu: close on outside click or Escape.
  var menu = document.querySelector('[data-dw-menu]');
  if (menu) {
    document.addEventListener('click', function (event) {
      if (menu.open && !menu.contains(event.target)) menu.open = false;
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && menu.open) {
        menu.open = false;
        menu.querySelector('summary').focus();
      }
    });
  }

  // Sticky buy bar: visible once the main buy button has scrolled out of view,
  // hidden again while the final call-to-action is on screen.
  var sticky = document.querySelector('[data-dw-sticky]');
  var mainCta = document.querySelector('[data-dw-main-cta]');
  if (sticky && mainCta && 'IntersectionObserver' in window) {
    var mainVisible = true;
    var finalVisible = false;
    var update = function () {
      sticky.classList.toggle('is-visible', !mainVisible && !finalVisible);
      var hidden = mainVisible || finalVisible;
      sticky.setAttribute('aria-hidden', String(hidden));
      sticky.inert = hidden;
    };
    new IntersectionObserver(function (entries) {
      mainVisible = entries[0].isIntersecting || entries[0].boundingClientRect.top > 0;
      update();
    }).observe(mainCta);
    var finalCta = document.querySelector('[data-dw-final-cta]');
    if (finalCta) {
      new IntersectionObserver(function (entries) {
        finalVisible = entries[0].isIntersecting;
        update();
      }).observe(finalCta);
    }
  }
})();
